import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';

import "./Widget.js";

/**
    * class HSN.Widget.AddToBag
    *
    * Encapsulates the common functionality of the AddToBag Widget.
    **/
HSN.Widget.AddToBag = function () {
    var application;
    var commerceService;
    var deviceInformation;
    var isInOffCanvas;
    var addedBasketItemId;
    var addedBagIdentity;
    var doFinish;
    var refreshWhenDone;
    var waitlistMessageHtml = '<div id="waitlist-message"><div class="waitlist-message-container" role="dialog" aria-labeledby="waitlist-title"><div id="waitlist-title" class="title">this item is on waitlist</div><div class="waitlist-description"><span class="title" tabindex="0">what\'s waitlist?</span><ul ><li>When your item becomes available, we will automatically send it to you.</li><li>If your item doesn\'t come back in stock within 45 days, we will cancel your order and contact you via email.</li><li>Your credit card is only charged if your item is shipped.</li></ul></div><button id="join-waitlist" class="submit-button main-button blue" tabindex="0">join waitlist</button><button id="remove-product" class="submit-button minor-button" tabindex="0">back to product</button></div></div>';
    var dataLayer;
    /**
        * new HSN.Widget.AddToBag.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.AddToBag]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - isInOffCanvas (boolean): Are you calling the widget from the add to bag offcanvas?
        **/
    function init(config) {
        application = config.application;
        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;
        isInOffCanvas = config.isInOffCanvas;
        doFinish = (typeof config.doFinish === 'undefined' ? true : config.doFinish);
        refreshWhenDone = (typeof config.refreshWhenDone === 'undefined' ? false : config.refreshWhenDone);
    }

    function AddToBag(addToBag, addToBagCallback) {
        //Autoship disclaimer
        var isAutoship = !(addToBag.ProgramId == null) && !(addToBag.ProgramId == '');
        if (isAutoship) {
            HSN.RemoveWait();
            var autoshipProgramType = addToBag.ProgramCode;
            var autoshipFrequency = addToBag.Frequency;
            var autoshipModal = HSN.Instance().GetGenericConfirmModal();
            autoshipModal.SetInputData({ programType: autoshipProgramType, frequency: autoshipFrequency });
            autoshipModal.SetOkCallback(function () {
                HSN.SetWait();
                DoAddToBag(addToBag, addToBagCallback);
            });
            autoshipModal.Show("/autoship/notice");
            return false;
        }

        DoAddToBag(addToBag, addToBagCallback);
    }

    function DoAddToBag(addToBag, addToBagCallback) {
        var isExpressBuy = addToBag.ExpressBuy === 1;
        commerceService.AddToBag(addToBag, {
            callback: function (data) {
                if (data.basketItemId) {
                    addedBasketItemId = data.basketItemId;
                    addedBagIdentity = data.bagIdentity;
                }
                dataLayer = data.dataLayerUdo;

                HSN.DataLayer.sendData({ 'cartitem_webpid': addToBag.ProductId, 'cartitem_qty': addToBag.Quantity, 'cartitem_webid': addToBag.WebId, 'cartitem_webmid': addToBag.MatrixId });

                if (data.error !== '') {
                    var errorContent = '<div><div class="add-to-bag-error-container"><p>' + data.error + '</p><div id="sold-out-okay" class="submit-button main-button blue" tabindex="0">ok</div></div></div>';
                    ShowAddToBagError(errorContent);
                }
                else if (data.isWaitlist) {
                    ShowWaitlistError(function () {
                        if (isInOffCanvas) {
                            HSN.DataLayer.helpers.metricEvent(null, "CP:add", "previewwaitlist", addToBag.ProductId, addToBag.Quantity);
                        }
                        else {
                            HSN.DataLayer.helpers.metricEvent(null, "CP:add", "pdwaitlist", addToBag.ProductId, addToBag.Quantity);
                        }

                        HSN.DataLayer.helpers.hsnEvent(null, "WaitList", "Success", null, null);
                        data.isOffCanvasTestActive ? AddToBagFinishV2(isExpressBuy, addToBag.Quantity, data) : AddToBagFinish(isExpressBuy, addToBag.Quantity, data);
                    });

                    HSN.DataLayer.helpers.elementInteraction(null, "Modal", "Wait List");

                }
                else if (data.needsPersonalization) {
                    var form = document.createElement('form');
                    var inputId = document.createElement('input');
                    inputId.setAttribute('type', 'hidden');
                    inputId.setAttribute('name', 'Id');
                    inputId.setAttribute('value', addToBag.WebId);
                    form.appendChild(inputId);

                    form.action = '/products/personalization/get';
                    form.method = 'post';
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(form);
                    form.submit();
                }
                else if (data.needsEgiftPersonalization) {
                    setTimeout(function () { HandleNavigation('/products/egiftcard/show'); }, 200);
                }
                else {
                    HSN.DataLayer.helpers.addToBag(data.dataLayerUdo);

                    if (isExpressBuy) {
                        HSN.DataLayer.helpers.checkout(data.dataLayerUdo);
                        HSN.DataLayer.helpers.event(null, "hsn_event", "ExpressBuy", "Success", null, null, true);
                    } else {
                        HSN.DataLayer.helpers.event(null, "hsn_event", "AddToBag", "Success", null, null, true);
                    }

                    if (isInOffCanvas) {
                        HSN.DataLayer.helpers.metricEvent(null, "CP:add", "preview", addToBag.ProductId, addToBag.Quantity);
                    }
                    else {
                        HSN.DataLayer.helpers.metricEvent(null, "CP:add", "pd", addToBag.ProductId, addToBag.Quantity);
                    }

                    if (addToBagCallback) {
                        addToBagCallback();
                    }
                    HSN.OnCoremetricsLoad(function () {
                        window.cmCreateShopAction5Tag(data.CoremetricsData.Pfid, data.CoremetricsData.ProductName, data.CoremetricsData.Quantity, data.CoremetricsData.Price, data.CoremetricsData.ProductCategory, data.CoremetricsData.ProductCallout + '-_-' + data.CoremetricsData.Size + '-_-' + data.CoremetricsData.Color + '-_--_-' + data.CoremetricsData.ProductRatingAverage + '-_-' + data.CoremetricsData.ProductRatingCount + '-_-' + data.CoremetricsData.ProductBrandName + '-_--_--_-' + data.CoremetricsData.AbTestValue1 + '-_-' + data.CoremetricsData.FlexPayments + '-_-' + data.CoremetricsData.ExpressBuy + '-_--_--_--_--_-' + data.CoremetricsData.AbTestValue2 + '-_-' + data.CoremetricsData.AbTestValue3 + '-_-' + data.CoremetricsData.Division + '-_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_-');
                        window.cmDisplayShop5s();
                    });

                    data.isOffCanvasTestActive ? AddToBagFinishV2(isExpressBuy, addToBag.Quantity, data) : AddToBagFinish(isExpressBuy, addToBag.Quantity, data);
                }
            },
            errorCallback: function () {
                alert('Unfortunately there was an error attempting to add the item to your bag, please try again.');
                HSN.RemoveWait();
            }
        });
    }
    function AddToBagFinishV2(isExpressBuy, quantityAdded, addToBagResponse) {
        HSN.RemoveWait();
        if (doFinish) {
            if (isExpressBuy) {
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }
                setTimeout(function () { HandleNavigation('/checkout/order-review'); }, 200);
            }
            else {
                if (deviceInformation.IsNativeApp) {
                    setTimeout(function () { HandleNavigation('/checkout/bag'); }, 200);
                }
                else {
                    if (!deviceInformation.IsMobile) {
                        HSN.IncreaseBagIconCount(quantityAdded);
                    }
                    if (isInOffCanvas) {
                        application.GetProductPreviewOffCanvas().Hide();
                    }
                    if (refreshWhenDone) {
                        window.location.reload(true);
                    }
                    else {
                        application.GetAddedToBagOffCanvas().Show(addToBagResponse.bagIdentity, addToBagResponse.bagItemIdentity);
                    }
                }
            }
        }
        else {
            application.Events.Trigger(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, addedBasketItemId, addedBagIdentity);
        }
    }
    function AddToBagFinish(isExpressBuy, quantityAdded, addToBagResponse) {
        if (doFinish) {
            if (isExpressBuy) {
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }

                if (isShowWarrantyUpsell(addToBagResponse)) {
                    showWarrantyUpsell(addToBagResponse.basketItemId, isExpressBuy);
                }
                else {
                    setTimeout(function () { HandleNavigation('/checkout/order-review'); }, 200);
                }
            }
            else {
                if (!deviceInformation.IsMobile) {
                    HSN.IncreaseBagIconCount(quantityAdded);
                }
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }
                if (isShowWarrantyUpsell(addToBagResponse)) {
                    HSN.RemoveWait();
                    showWarrantyUpsell(addToBagResponse.basketItemId, isExpressBuy);
                }
                else {
                    if (refreshWhenDone) {
                        window.location.reload(true);
                    }
                    else if (deviceInformation.IsMobile) {
                        setTimeout(function () { HandleNavigation('/checkout/bag'); }, 200);
                    }
                    else {
                        if (addToBagResponse.isDestinationTestActive) {
                            setTimeout(function () { HandleNavigation('/checkout/bag'); }, 200);
                        }
                        else {
                            HSN.RemoveWait();
                            application.GetBagFlyout().Open(7000);
                        }
                    }
                }
            }
        }
        else {
            HSN.RemoveWait();
            application.Events.Trigger(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, addedBasketItemId, addedBagIdentity);
        }
    }
    function isShowWarrantyUpsell(data) {
        var showWarrantyMobileAbTest = deviceInformation.IsMobile && !data.isWarrantySelected && data.isWarrantyAvailable;
        if (showWarrantyMobileAbTest) {
            return showWarrantyMobileAbTest;
        }

        return !data.isWarrantySelected && data.isWarrantyAvailable && !deviceInformation.IsMobile;
    }
    function showWarrantyUpsell(basketItemId, isExpressBuy) {
        var warrantyUpsellModal = application.GetWarrantyUpsellModal({ IsExpressBuy: isExpressBuy });
        warrantyUpsellModal.Show(basketItemId, isExpressBuy, function () {
            warrantyUpsellModal.Close.focus();
        });
    }
    function HandleNavigation(url) {
        if (application.DeviceInformation.IsNativeApp) {
            url = gap.FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command;
            var eventName = "Add to Bag";

            var appFeatureLocalytics = false;
            if (application.GetAppFeatures("localtyics", "1")) {
                appFeatureLocalytics = true;
            }
            var appGapEvent = false;
            if (application.GetAppFeatures("gapevents", "1")) {
                appGapEvent = true;
            }

            var attributes = buildAppData(dataLayer, url, appFeatureLocalytics, appGapEvent);
            if (appGapEvent) {
                command = 'hsn://HSNWebView.GapEvents/' + eventName + '/' + encodeURIComponent(JSON.stringify(attributes));
            }
            else if (appFeatureLocalytics) {
                command = 'hsn://HSNWebView.TagLocalytics/GoTo/' + eventName + '/' + encodeURIComponent(JSON.stringify(attributes)) + '/' + encodedUrl;
            } else {
                command = gap.BuildGapCommand(url);
            }
            gap.ExecCommand(command);
        }
        else {
            window.location.href = url;
        }
    }

    //builds app data for Localytics and Branch
    function buildAppData(dataLayerUdo, nextUrl, appLocalyticsEnabled, appGapEventEnabled) {
        var prodSku = undefined;
        var prodSkuLocal = undefined;
        var prodId = undefined;
        var prodMatrixId = undefined;
        var prodCats = dataLayerUdo.categories;
        var sfName = undefined;
        var sfNameLocal = undefined;
        var department = undefined;
        var departmentLocal = undefined;
        var catName = undefined;
        var catNameLocal = undefined;
        var prodName = undefined;
        var brand = undefined;
        var brandLocal = undefined;
        var price = undefined;
        var regular_price = undefined;
        var priceLocal = undefined;
        var quantity = undefined;

        if (prodCats) {
            for (i = 0; i < prodCats.length; i++) {
                if (prodCats != "undefined") {
                    if (typeof prodCats[i][0] !== "undefined") {
                        sfName = prodCats[i][0].Name;
                        sfNameLocal = prodCats[i][0].Name;
                    }
                    else {
                        sfName = "";
                        sfNameLocal = "None";
                    }

                    if (typeof prodCats[i][1] != "undefined") {
                        department = prodCats[i][1].Name;
                        departmentLocal = prodCats[i][1].Name;
                    }
                    else {
                        department = "";
                        departmentLocal = "None";
                    }

                    if (typeof prodCats[i][2] != "undefined") {
                        catName = prodCats[i][2].Name;
                        catNameLocal = prodCats[i][2].Name;
                    }
                    else {
                        catName = "";
                        catNameLocal = "None";
                    }
                }
            }
        }

        if (typeof dataLayerUdo.product_name != "undefined") {
            prodName = dataLayerUdo.product_name[0].toString();
        }
        if (typeof dataLayerUdo.product_id != "undefined") {
            prodId = dataLayerUdo.product_id[0];
        }
        if (typeof dataLayerUdo.product_sku != "undefined") {
            prodSku = Number(dataLayerUdo.product_sku[0].toString());
            prodSkuLocal = dataLayerUdo.product_sku[0].toString();
        }
        if (typeof dataLayerUdo.matrix_id != "undefined") {
            prodMatrixId = dataLayerUdo.matrix_id[0];
        }
        if (typeof dataLayerUdo.product_brand_name != "undefined") {
            brand = dataLayerUdo.product_brand_name[0].toString();
        }
        if (typeof dataLayerUdo.product_sale_price != "undefined") {
            price = parseFloat(dataLayerUdo.product_sale_price[0].toString());
            priceLocal = dataLayerUdo.product_sale_price[0].toString();
        }
        if (typeof dataLayerUdo.product_original_price != "undefined") {
            regular_price = parseFloat(dataLayerUdo.product_original_price[0].toString());
        }

        quantity = HSN.DataLayer.getValueForKey("cartitem_qty");

        var attributes = {};

        if (appGapEventEnabled) {

            var prodItemAttr = [];

            var prodAttributes = {
                "product_id": prodId,
                "product_sku": prodSku,
                "matrix_id": prodMatrixId,
                "product_name": prodName,
                "price": price,
                "regular_price": regular_price,
                "storefront": sfName,
                "department": department,
                "category": catName,
                "brand": brand,
                "quantity": quantity
            };

            prodItemAttr.push(prodAttributes);

            var attributes = {
                "Products": prodItemAttr,
                "nextUrl": nextUrl
            };
        }
        else if (appLocalyticsEnabled) {
            attributes = {
                "Name": prodName,
                "ID": prodSkuLocal,
                "Storefront": sfNameLocal,
                "Department": departmentLocal,
                "Category": catNameLocal,
                "Brand": brand,
                "Price": priceLocal
            };
        }

        return attributes;
    }

    function BindModalHandlers(modalScope, finishCallback) {
        var joinButton = $('.waitlist-message-container #join-waitlist', modalScope.Content);
        var removeButton = $('.waitlist-message-container #remove-product', modalScope.Content);

        var hideAndFocus = function () {
            modalScope.Hide();
            $('div.buy-selector span.add-to-bag-proxy').focus();
        };

        $('.add-to-bag-error-container .submit-button', modalScope.Content).on('click keydown', function () {
            modalScope.Hide();
            return false;
        });
        joinButton.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                hideAndFocus();
                if (finishCallback) {
                    finishCallback();
                }
            }
            else if (e.type === 'keydown' && e.key === 'Tab') {
                e.preventDefault();
                removeButton.focus();
            }
        });
        removeButton.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                commerceService.RemoveBagItem({ bagIdentity: addedBagIdentity, bagItemId: addedBasketItemId }, {
                    callback: function () {
                        hideAndFocus();
                    },
                    scope: this
                });
            }
            else if (e.type === 'keydown' && e.key === 'Tab') {
                e.preventDefault();
                joinButton.focus();
            }

        });

        application.Events.On(HSN.PageIdModal.EVENT.SHOW_COMPLETE, function () {
            if (joinButton.is(':visible')) {
                joinButton.focus();
            }
        });

    }
    function ShowAddToBagError(content) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(content, true);
        BindModalHandlers(modalReference);
        $('.add-to-bag-error-container .submit-button', modalReference.Content).focus();

        return false;
    }
    function ShowWaitlistError(finishCallback) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(waitlistMessageHtml, true);
        BindModalHandlers(modalReference, finishCallback);
        $('.waitlist-message-container #join-waitlist', modalReference.Content).focus();
        return false;
    }
    return {
        init: init,
        AddToBag: AddToBag
    }
};
HSN.Widget.AddToBag.EVENT = {
    ADD_SUCCESS: 'HSN.Widget.AddToBag:ADD_SUCCESS'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/AddToBag.js